/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateRoleResourceForUserRequestUserAccountGroupInner
 */
export interface UpdateRoleResourceForUserRequestUserAccountGroupInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleResourceForUserRequestUserAccountGroupInner
     */
    'role': UpdateRoleResourceForUserRequestUserAccountGroupInnerRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateRoleResourceForUserRequestUserAccountGroupInner
     */
    'resourceId': string;
}

export const UpdateRoleResourceForUserRequestUserAccountGroupInnerRoleEnum = {
    admin: 'USER_ACCOUNT_ADMIN',
    assist: 'USER_ACCOUNT_ASSIST'
} as const;

export type UpdateRoleResourceForUserRequestUserAccountGroupInnerRoleEnum = typeof UpdateRoleResourceForUserRequestUserAccountGroupInnerRoleEnum[keyof typeof UpdateRoleResourceForUserRequestUserAccountGroupInnerRoleEnum];


